<template>
  <div>
    <a-card title="周排查">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="请输入关键词" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 280px; margin-bottom: 12px">
          <a-range-picker v-model="searchForm.check_date_range" :placeholder="['开始日期', '结束日期']"
            style="width: 100%; border-radius: 6px;" @change="onDateRangeChange" allowClear format="YYYY-MM-DD"
            :show-time="false" size="default" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openFormModal(form)">新增</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :pagination="pagination" :columns="columns" :dataSource="items" rowKey="id"
          :loading="loading" @change="tableChange">
          <div slot="controlDate" slot-scope="text">
            {{ formatDateRange(text) }}
          </div>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? "激活" : "冻结" }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="copy" size="small" @click="copyRecord(item)">复制</a-button>
              <a-button icon="eye" size="small" @click="openViewModal(item)">查看</a-button>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal 
      :visible="visible" 
      :form="targetItem" 
      :clientsClassificationOptions="clientsClassificationItems"
      :isReadonly="isReadonly"
      @cancel="visible = false"
      @create="create" 
      @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { weekControlList, weekControlDel } from "@/api/control";

export default {
  name: "Warehouse",
  components: {
    FormModal: () => import("./FormModal.vue"),
  },
  data() {
    return {
      columns: [
        {
          title: "检查日期",
          dataIndex: "others.check_date",
          width: "120px",
        },
        {
          title: "管控日期范围",
          dataIndex: "others.control_date",
          scopedSlots: { customRender: "controlDate" },
          width: "200px",
          align: "center",
        },
        {
          title: "记录编号",
          dataIndex: "others.record_code"
        },
        {
          title: "上周回顾",
          dataIndex: "others.review"
        },
        {
          title: "本周排查",
          dataIndex: "others.troubleshooting"
        },
        {
          title: "整改措施",
          dataIndex: "others.measures"
        },
        {
          title: "备注",
          dataIndex: "others.remark"
        },
        {
          title: "参加人员",
          dataIndex: "others.participants"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "210px",
        },
      ],
      pagination: { current: 1, total: 0, pageSize: 10 },
      searchForm: {
        search: "",
        page: 1,
        page_size: 10,
        check_date_start: null,  // 开始日期
        check_date_end: null,    // 结束日期
        check_date_range: null   // 日期范围选择器的值
      },
      loading: false,
      items: [],
      clientsClassificationItems: [],
      visible: false,
      targetItem: { others: {} },
      form: { others: {} },
      isReadonly: false,
      importLoading: false,
    };
  },
  methods: {
    onDateRangeChange(dates, dateStrings) {
      // 当日期范围改变时，设置开始和结束日期
      if (dates && dates.length === 2) {
        this.searchForm.check_date_start = dateStrings[0];
        this.searchForm.check_date_end = dateStrings[1];
      } else {
        this.searchForm.check_date_start = null;
        this.searchForm.check_date_end = null;
      }
      // 自动触发搜索
      this.search();
    },
    onDateChange(date, dateString) {
      // 当日期改变时，格式化日期为后端需要的格式
      this.searchForm.check_date = dateString || null;
      // 自动触发搜索
      if (dateString) {
        this.search();
      }
    },
    openViewModal(item) {
      this.isReadonly = true;
      this.targetItem = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    openFormModal(item) {
      this.isReadonly = false;
      this.targetItem = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    formatDateRange(dateRange) {
      if (!dateRange) return '';

      try {
        // 尝试解析JSON字符串数组
        let dates = dateRange;
        if (typeof dateRange === 'string') {
          dates = JSON.parse(dateRange);
        }

        if (Array.isArray(dates) && dates.length >= 2) {
          // 格式化开始日期
          const startDate = new Date(dates[0]);
          const startYear = startDate.getFullYear();
          const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
          const startDay = String(startDate.getDate()).padStart(2, '0');
          const startHour = String(startDate.getHours()).padStart(2, '0');
          const startMinute = String(startDate.getMinutes()).padStart(2, '0');

          // 格式化结束日期
          const endDate = new Date(dates[1]);
          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');
          const endHour = String(endDate.getHours()).padStart(2, '0');
          const endMinute = String(endDate.getMinutes()).padStart(2, '0');

          return `${startYear}-${startMonth}-${startDay} ${startHour}:${startMinute} 至 ${endYear}-${endMonth}-${endDay} ${endHour}:${endMinute}`;
        }
        return dateRange;
      } catch (e) {
        console.error('日期格式化错误:', e);
        return dateRange;
      }
    },
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      weekControlList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    update() {
      this.list();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      this.list();
    },
    copyRecord(item) {
      // 复制记录,移除id和创建时间等字段,保留业务数据
      const copiedItem = { 
        others: { ...item.others }
      };
      // 清除不需要复制的字段
      delete copiedItem.id;
      delete copiedItem.create_at;
      delete copiedItem.update_at;
      
      this.targetItem = copiedItem;
      this.visible = true;
      this.$message.success('已复制记录,请修改后保存');
    },
    destroy(id) {
      weekControlDel({ id: id })
        .then((data) => {
          this.$message.success("删除成功");
          this.list();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
